var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('wtk-alert'),_c('wtk-confirm'),_c('wtk-loading'),_c('wtk-prompt'),_c('wtk-toast')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }